import { Injectable } from "@angular/core";
import { RemoteGatewayFactory } from "../gateways/remote-gateway-factory";
import { BackendUrl } from "../models/domains/urls/back-end.url";
import { UserTerm } from "../models/domains/user-term/user-term.model";

@Injectable()
export class UserTermRepository {
  constructor(
    private remoteGatewayFactory: RemoteGatewayFactory
  ) {}

  async acceptUserTerm(termId : string) {
    const headers = { "Content-Type": "application/json" };

    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      return await remoteGateway.putWithHeaders(new BackendUrl(`/api/user/term/${termId}`),{}, headers);
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  async validateUserTerm(): Promise<UserTerm> {
    const headers = {
      "Content-Type": "application/json"
    };

    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      const data : UserTerm = await remoteGateway.getWithHeaders(new BackendUrl('/api/user/term'), headers);
      return data;
    } catch (error) {
      return await Promise.reject(error);
    }
  }

}
